import React from 'react';
import { useLeadByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { CommunicationHub } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const LeadCommunicationHub = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { id } = useParams() as { id: string };
  const { data: { isFinalStatus } = {} } = useLeadByIdQuery({ id }, { skip: !id });
  return (
    <HasAccess role={PERMISSIONS.notes.note.read}>
      <CommunicationHub
        entity={'LEAD'}
        hasAccessToWrite={hasAccess(PERMISSIONS.notes.note.write)}
        hasAccessToOtherNoteWrite={hasAccess(PERMISSIONS.notes.other_note.write)}
        hasAccessToOtherNoteDelete={hasAccess(PERMISSIONS.notes.other_note.delete)}
        isFinalStatus={isFinalStatus}
      />
    </HasAccess>
  );
});
